var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "history-list", class: { in_modal: _vm.inModal } },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.list, function (d, i) {
        return _c("li", { key: i }, [
          _vm._v(
            "\n        Решения отсутствуют " +
              _vm._s(_vm.dateParser(d)) +
              " г.\n    "
          ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("hr")])
  },
]
render._withStripped = true

export { render, staticRenderFns }